document.addEventListener("DOMContentLoaded", () => {
    let userConsentStatus;

    // Initialize didomiEventListeners if not already initialized
    window.didomiEventListeners = window.didomiEventListeners || [];

    // Promise for Shopify readiness
    const shopifyReady = new Promise((resolve, reject) => {
        window.Shopify.loadFeatures(
        [
            {
            name: 'consent-tracking-api',
            version: '0.1',
            },
        ],
        (error) => {
            if (error) {
            console.error("Shopify loadFeatures error:", error);
            reject(error);
            return;
            }
            resolve();
        }
        );
    });

    // Function to run when both Didomi and Shopify are ready
    function syncsReady() {
        setShopifyConsent();

        // Attach listener for consent changes after initial setup
        window.didomiEventListeners.push({
        event: 'consent.changed',
        listener: (context) => {
            userConsentStatus = Didomi.getUserStatus();
            setShopifyConsent();
        }
        });
    }

    // Promise for Didomi readiness
    const didomiReady = new Promise((resolve) => {
        window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push((Didomi) => {
        userConsentStatus = Didomi.getUserStatus();
        resolve();
        });
    });

    // Wait for both promises to resolve
    Promise.all([didomiReady, shopifyReady])
        .then(syncsReady)
        .catch((error) => {
        console.error("Error:", error);
        });

    function setShopifyConsent() {
        // Initialize an object to hold the Shopify consent values, setting them initially to true
        let shopifyConsent = {
        "analytics": true,
        "marketing": true,
        "preferences": true,
        "sale_of_data": true
        };

        // Define arrays for each signal's associated purposes
        const analyticsPurposes = ["cookies", "measure_ad_performance", "measure_content_performance"];
        const marketingPurposes = ["select_basic_ads", "create_ads_profile", "select_personalized_ads", "market_research"];
        const preferencesPurposes = ["create_content_profile", "select_personalized_content"];

        // Check disabled purposes to determine if any signals should be turned off
        userConsentStatus.purposes.consent.disabled.forEach((purpose) => {
            if (analyticsPurposes.includes(purpose)) {
                shopifyConsent.analytics = false;
            }
            if (marketingPurposes.includes(purpose)) {
                shopifyConsent.marketing = false;
            }
            if (preferencesPurposes.includes(purpose)) {
                shopifyConsent.preferences = false;
            }
            if (purpose === "market_research") {
                shopifyConsent.sale_of_data = false;
            }
        });

        // Override previous consent settings if Shopify Stats is disabled as a vendor
        let shopifyVendorConsent = false;

        userConsentStatus.vendors.consent.enabled.forEach((vendor) => {
            if (vendor == "c:shopify-stats") {
                shopifyVendorConsent = true;
            }
        });

        if (shopifyVendorConsent == false) {
            shopifyConsent = {
                "analytics": false,
                "marketing": false,
                "preferences": false,
                "sale_of_data": false
            };         
        }

        // Call Shopify's function to set tracking consent based on the mapped values
        window.Shopify.customerPrivacy.setTrackingConsent(
            shopifyConsent,
            () => console.log(window.Shopify.customerPrivacy.currentVisitorConsent()) // Displays Shopify signal consent status after updating, remove this in prod.
        );
    }
});